import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  getAllUsers: (query: QueryProps) => `/user/?${objToQueryString(query)}`,
  getUsersForRecovery: query => `/user/recovery/?${objToQueryString(query)}`,
  recoverUsers: () => '/user/recovery/',
  recoverUsersByRequestUuid: (requestUuid: string) =>
    `/user/recovery/request/${requestUuid}/`,
  removeUsers: () => '/user/remove-users/',
  removeUser: (userUuid: string, permanent: boolean) =>
    `/user/${userUuid}/?permanent=${permanent}`,
  removeUsersPermanently: () => '/user/remove-users-permanently/',
};
